const OrdersSource = Object.freeze({
  FunNow: 0,
  LINECoupon: 1,
  LINESpot: 2,
  Ezbook: 3,
  BookingEngine: 4,
  Partner: 5,
  FunBookV2: 6,
  Niceday: 7,
  Eatigo: 8,
  Tableapp: 9
})

const OrdersSourceToBrandID = Object.freeze({
  0: 1,
  7: 2,
  8: 3
})

const OrdersPenaltyStatus = Object.freeze({
  None: 0,
  Success: 1,
  Failure: 2,
  NoPenalty: 3
})

const OrdersPenaltyType = Object.freeze({
  Cancel: 0,
  NoShow: 1
})

const OrdersPenaltyChargeType = Object.freeze({
  NoCharge: 0,
  Penalty: 1
})

export function getRedeemStatus (usedTime, noShowAt) {
  return (noShowAt) ? 'no_show'
    : (usedTime) ? 'redeemed' : 'unredeemed'
}

export {
  OrdersSource,
  OrdersSourceToBrandID,
  OrdersPenaltyStatus,
  OrdersPenaltyType,
  OrdersPenaltyChargeType
}
